import { EpiPage } from '@api/types';
import { CategoryBlock, ContentArea } from '@components';

export type CategoryPageContentProps = {
  page?: EpiPage;
};

export const CategoryPageContent = ({ page = {} }: CategoryPageContentProps) => {
  const { content } = page;
  return (
    <>
      <ContentArea content={content} enableNativeOverlay />
      <CategoryBlock page={page} />
    </>
  );
};
